import _ from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import RoleRequire from "@/helpers/auth/RoleRequire";
import { AdminModelsTable } from "@/types/formDataTypes";
import { Button } from "@/ui/Button";
import { Input } from "@/ui/Input/Input";
import { ColumnDef } from "@tanstack/react-table";
import { MenuDataTable } from "@/ui/DataTable/MenuDataTable";
import { DeviceModel } from "@/types/types";

export default function EquipmentsGrid({
  models,
  onClose,
}: {
  models: DeviceModel[];
  onClose: () => void;
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  let nodes = models?.map((data) => {
    return {
      id: String(data.id),
      name: data.attributes.name,
      structure: data.attributes.structure,
    };
  });

  // Сортировка по умолчанию
  nodes = _.sortBy(nodes, []);
  let data = { nodes };

  const handleSearch = (event: any) => {
    setSearch(event.target.value);
  };

  // Фильтрация через поиск
  data = {
    nodes: data.nodes?.filter((item) =>
      search ? item.name?.toLowerCase().includes(search.toLowerCase()) : true,
    ),
  };

  const columns: ColumnDef<AdminModelsTable>[] = [
    {
      id: "model_name",
      accessorFn: (row) => row.name,
      header: t("name"),
      size: 1000,
      cell: (props) => (
        <div className="max-w-[420px]">
          <div className="font-medium truncate">{props.row.original.name}</div>
        </div>
      ),
    }
  ];

  function selectModel(model: any) {
    onClose();
  }

  function addAdminModel() {
    navigate("/admin/models/new");
    onClose();
  }

  return (
    <>
      <div className="flex flex-col">
        <div className="flex flex-row w-full h-14 items-center gap-4 px-6 justify-between">
          <Input
            className="h-8"
            placeholder={t("search")}
            onChange={handleSearch}
            value={search}
            autoComplete="off"
            width="100%"
          />

          <RoleRequire role="maintainer">
            <Button
              variant={"default"}
              size={"md"}
              onClick={() => addAdminModel()}
            >
              {t("add")}
            </Button>
          </RoleRequire>
        </div>
      </div>

      {!data.nodes?.length ? ( // Заглушка для отсутствия данных при поиске
        <div className="flex w-full h-full justify-center items-center">
          {t("no_data")}
        </div>
      ) : (
        <MenuDataTable
          route="/admin/models"
          data={data.nodes}
          columns={columns}
          onClickRow={selectModel}
        />
      )}
    </>
  );
}
